import { PayloadAction, createSlice } from '@reduxjs/toolkit'
import { PURGE } from 'redux-persist'

export interface ProcessingState {
  displayProcessingModal: boolean
  startConfirmTime: number
  endConfirmTime: number
  elapsedConfirmTime: number | undefined
  // Snapshot of ProcessingModal's `sendEndTransactionMessage` decision, captured before
  // navigation to /purchase-success. PostCheckout asset CTA clicks flip postCheckout.enabled
  // via useAssetEligible, so recomputing from `postCheckout.enabled` on the success page
  // can send the endTransaction that the post-capture flow intentionally suppresses.
  sendEndTransactionMessage: boolean | undefined
}

export const processingInitialState: ProcessingState = {
  displayProcessingModal: false,
  startConfirmTime: 0,
  endConfirmTime: 0,
  elapsedConfirmTime: undefined,
  sendEndTransactionMessage: undefined,
}

const slice = createSlice({
  name: 'processing',
  initialState: processingInitialState,
  reducers: {
    setDisplayProcessingModal(state: ProcessingState, action: PayloadAction<boolean>) {
      state.displayProcessingModal = action.payload
    },
    setEndConfirmTime(state: ProcessingState, action: PayloadAction<number>) {
      state.endConfirmTime = action.payload
      state.elapsedConfirmTime = action.payload - state.startConfirmTime
    },
    setStartConfirmTime(state: ProcessingState, action: PayloadAction<number>) {
      state.startConfirmTime = action.payload
    },
    setSendEndTransactionMessage(state: ProcessingState, action: PayloadAction<boolean>) {
      state.sendEndTransactionMessage = action.payload
    },
  },
  extraReducers: (builder) => {
    builder.addCase(PURGE, () => processingInitialState)
  },
})

export const { setDisplayProcessingModal, setEndConfirmTime, setStartConfirmTime, setSendEndTransactionMessage } = slice.actions

export default slice.reducer
